'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      // type: 'line',
      height: 300,
      // spacingBottom: 50,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    // colors: ['#2b908f'],
    title: {text: '1日のデマンド実績'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      rotation: -45
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        for (let point of this.points) {
          tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
          tip_format += point.y + " kW";
          tip_format += "</span>";
        }

        return tip_format;
      }
    },
    series: []
  };

  return chartConfig;
};



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/demand/daily/compare-graph-daily.config.js